export const FIELD_TO_RECOMMENDATION_COLUMN_TITLE_KEY: Record<string, string> = {
  name: 'alertsRecommendations:column.name',
  description: 'alertsRecommendations:column.description',
  blockIds: 'alertsRecommendations:column.block',
  fieldIds: 'alertsRecommendations:column.field',
  padIds: 'alertsRecommendations:column.pad',
  indexFormat: 'alertsRecommendations:column.indexFormat',
  sourceOption: 'alertsRecommendations:column.sourceOption',
  dataType: 'alertsRecommendations:column.dataType',
  paramValue: 'alertsRecommendations:column.parameter',
  userRecommendation: 'alertsRecommendations:column.userRecommendation',
  recommendationMin: 'alertsRecommendations:column.recommendationMin',
  recommendationMax: 'alertsRecommendations:column.recommendationMax',
  recommendationDelta: 'alertsRecommendations:column.recommendationDelta',
  context: 'alertsRecommendations:column.context',
  stageIds: 'alertsRecommendations:contextTitle.stage',
  wellboreTypeIds: 'alertsRecommendations:contextTitle.wellboreType',
  trajectoryTypeIds: 'alertsRecommendations:contextTitle.trajectoryType',
  sectionTypeIds: 'alertsRecommendations:contextTitle.section',
  holeTypes: 'alertsRecommendations:contextTitle.holeType',
  stratUnitTypeIds: 'alertsRecommendations:contextTitle.stratUnit',
  reservoirIds: 'alertsRecommendations:contextTitle.reservoir',
  runTypeIds: 'alertsRecommendations:contextTitle.run',
  operationIds: 'alertsRecommendations:contextTitle.operation',
} as const;
